/**
 * File promo.js.
 * Handles logic for the promo feature
 */

function promoInit($) {
  const promoForms = document.querySelectorAll('.promo-form');

  for (let i = 0; i < promoForms.length; i++) {
    const promoForm = promoForms[i];
    const promoInput = promoForm.querySelector('.promo-form__input');
    const emailSubmit = promoForm.parentElement.querySelector('.email-capture__submit');
    const emailInput = $(promoForm.parentElement.querySelector('.email-capture__input'));
    const promoApply = promoForm.querySelector('.promo-form__apply');
    const promoReset = promoForm.querySelector('.promo-form__reset');
    const promoApplied = promoForm.querySelector('.promo-form__applied');
    const promoDetails = promoForm.querySelector('.promo__details');
    const promoMessage = promoForm.querySelector('.promo__details-msg');
    const autoPromoCode = (!!window?.ajaxpromo?.auto_promo) ? window?.ajaxpromo?.auto_promo : false;
    const useAjax = !autoPromoCode && !!window?.ajaxpromo?.ajaxurl;
    const useDefaultCode = !autoPromoCode && !!window?.ajaxpromo?.use_default_code;
    const defaultPromoCode = useDefaultCode ? 'nopromocode' : '';
    const adBase = (!!window?.ajaxpromo?.ad_base) ? window.ajaxpromo.ad_base + '_' : '';
    let promoEntered = false;
    let promoResult = false;

    function enableSubmit() {
      const enable = (promoResult == 'saved') && validateEmail(emailInput.val());

      if (!enable) {
        emailSubmit.setAttribute('disabled', 'disabled');
      } else {
        emailSubmit.removeAttribute('disabled');
      }
    }

    function clearPromoInput() {
      promoInput.value = '';
      promoEntered = false;
    }

    function enableEmailInput(enable = true) {
      if (!enable) {
        emailInput.attr('disabled', 'disabled');
      } else {
        emailInput.removeAttr('disabled');
      }
    }

    function updateBannerText(state, disp) {
      if (!promoApplied) return;

      if (state == 'entered') {
        promoApplied.innerText = "Validating promo code...";
      } else {
        promoApplied.innerText = disp ? promoEntered + ' ' + state : '';
      }
    }

    function toggleClasses(state, disp) {
      // clear current state
      if (promoResult) {
        promoForm.classList.toggle('promo-form--' + promoResult, false);
        updateBannerText('clear', false);
      }

      // store new state
      promoResult = state;

      // return if no state is set
      if (!state) {
        return;
      }

      if (promoMessage && !useAjax) {
        // display promo message if set
        const dispmsg = disp && state == 'saved';
        promoDetails.classList.toggle('promo__details--has-msg', dispmsg);
      } else {
        // update classes and text
        updateBannerText(state, disp);
        promoForm.classList.toggle('promo-form--' + state, disp);
      }
    }

    function resetPromo() {
      toggleClasses(false, false);
      clearPromoInput();
      enableSubmit();
    }

    function applyPromo(promoValue, status) {
      if (promoValue && promoValue == promoEntered) {
        sendPromoSegmentEvent(promoEntered, status);
        toggleClasses('saved', true);
        enableSubmit();
      }
    }

    function invalidPromo(promoValue) {
      if (!!promoValue && promoValue == promoEntered) {
        sendPromoSegmentEvent(promoEntered, 'Invalid');
        toggleClasses('invalid', true);
        clearPromoInput();
        enableSubmit();
      }
    }

    function validatePromo() {
      if (!promoInput.value) {
        return;
      }

      promoEntered = promoInput.value.toUpperCase();

      const regex = /^[A-Z0-9]{3,20}$/;
      const valid = regex.test(promoEntered);

      if (!valid) {
        invalidPromo(promoEntered);
        return;
      }

      if (!useAjax) {
        applyPromo(promoEntered, 'Saved');
        return;
      }
    
      toggleClasses('entered', true);

      const ajaxArgs = {
        url: ajaxpromo?.ajaxurl,
        data: {
          action: 'promo_codes',
          promo: promoEntered,
          pid: ajaxpromo?.pid,
          pcp: ajaxpromo?.pcp,
        },
        successFunc: handleAjaxSuccess,
        errorFunc: handleAjaxError,
      };

      sendAjaxPost(ajaxArgs);
    }

    function applyQSPs(str) {
      
      if (!str) return;

      var qspArray = str.split('&');
      
      for (var i = 0; i < qspArray.length; i++) {
        var qsp = qspArray[i].split('=');
        var key = qsp[0];
        var value = qsp[1];
        
        if (key && value) {
          // create .hidden_promo input element
          var hiddenToken = document.createElement('input');
          hiddenToken.type = 'hidden';
          hiddenToken.name = key;
          hiddenToken.classList.add('hidden_promo');
          hiddenToken.value = value;
          promoForm.appendChild(hiddenToken);
        }
      }
    }

    function handleAjaxSuccess(result) {
      var data = JSON.parse(result);
      var success = !!data.success;
      var promoValue = '' + data.promo;
      var qsps = '' + data.qsps;

      if (adBase) {
        qsps = qsps + "&ad=" + adBase + promoValue.toLowerCase()
      }

      if (success) {
        applyQSPs(qsps);
        applyPromo(promoValue, 'Valid');
        enableEmailInput(true);
      } else {
        invalidPromo(promoValue);
        enableEmailInput(false);
      }
    }

    function handleAjaxError(html, textStatus, errorThrown) {
      invalidPromo(promoEntered);
      promoEntered = 'Error:';
      updateBannerText(errorThrown, true)
    }

    function sendPromoSegmentEvent(promo, status) {
      const promoLocation = window.location.href;

      const properties = {
        interaction_type: "INTERACTION_TYPE_PROMO_CODE_ENTERED",
        interaction_details: {
          location: promoLocation,
          action_detail: promo,
        }, // fbc & fbc will be added later
        additional_data: [
          {
            key: "status",
            value: status
          }
        ]
      }

      segmentGenericEvent('track', properties);

      // Analytics SDK double fire
      fireAnalyticsEvent(Track.WebFieldFilled, {
        unique_id: 'promo_code_entered',
        label: promo,
        item_details: {
          "promo_code_entered": {
            "status": status,
            "button_location": promoLocation
          }
        }
      });
    }

    function captureEnrollLinkClick(e) {
      e.preventDefault();
      const $target = $(e.target);
      const link = $target.attr('href');
      const promo = promoEntered || defaultPromoCode;
      const qspPrefix = (link.indexOf('?') > -1) ? '&' : '?';

      const newlink = link + qspPrefix + "ad=" + adBase + promo.toLowerCase();
      window.location.href = newlink;
      return false;
    }

    // add promo code validation listeners
    window.addEventListener('load', validatePromo);
    if (!autoPromoCode) {
      promoApply.addEventListener('click', validatePromo);
      promoReset.addEventListener('click', resetPromo);
    }

    // enable submit if valide email address
    emailInput.on('blur keyup input', function(){ enableSubmit(); });

    // auto-add promo code on submit
    if (autoPromoCode || useDefaultCode) {
      $('.enroll-link').on('click', captureEnrollLinkClick);
    }
    
  }
};

/*-----------------------------------------------------*/
/* https://chime.atlassian.net/browse/OM-1966
/*-----------------------------------------------------*/
/* The new MyPay DM LP uses the Promo Codes module
/* However, it requires a little customization. 
/* It should hide the email capture field by default,
/* and only show it when the promo code is valid.
/* Since this is specific to this page only,
/* we will add a conditional to check the current URL.
/*----------------------------------------------------*/
function hideEmailCaptureByDefault() {
  const target = document.querySelector('div.promo-form');
  const emailInp = document.querySelector('div.email-capture__input-val');
  const emailBtn = document.querySelector('button.email-capture-submit');

  emailInp.style.display = 'none';
  emailBtn.style.display = 'none';
  emailBtn.disabled = true;

  if (target && emailInp && emailBtn) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.target.classList.contains('promo-form--saved')) {
          emailInp.style.display = 'block';
          emailBtn.style.display = 'inline';
          emailBtn.disabled = false;
        } else {
          emailInp.style.display = 'none';
          emailBtn.style.display = 'none';
          emailBtn.disabled = true;
        }
      });
    });
    observer.observe(target, { attributes: true, attributeFilter: ['class'] });

    const emailCaptureError = document.querySelector('div.email-capture-error.email-capture__validation.copy--disclaimer');
    if (emailCaptureError && emailCaptureError.style.display !== 'none') {
      // show DFP banner code
      emailCaptureError.style.top = '-73px';
    }
  }
}

let currentURL = getPath();
const urls = [ 
  '/mypay-p-10/', 
  '/apply-chimemail/', 
  '/apply-spotmemail/', 
  '/apply-mail10/', 
  '/apply-mail25/', 
  '/apply-mail75/', 
  '/apply-mail100/' 
];

if(urls.includes(currentURL)) {
  window.addEventListener('load', hideEmailCaptureByDefault);
}